import {stage} from '../stage';
import {ResourcesConfig} from "aws-amplify";

// FNP-872: sign-in goes through the auth broker with code + PKCE. The domain is
// the broker's execute-api host plus the /prod stage path; ide uses the dev broker.
export const cognito = {
    prod: {
        // domain: 'flexinet-main-user-pool-prod.auth.us-west-2.amazoncognito.com',
        domain: 'aty3ojbu1h.execute-api.us-west-2.amazonaws.com/prod',
        redirectSignIn: ['https://www.flexi.domains'],
        redirectSignOut: ['https://portal.flexi.network'],
        region: 'us-west-2',
        userPoolId: 'us-west-2_bxdNeqDGn',
        userPoolClientId: '467rlh361q573kme7313svd3sb',
        identityPoolId: 'us-west-2:3e7d4b09-3858-460f-938b-b253eb14f1b7',
    },
    test: {
        // domain: 'flexinet-main-user-pool-test.auth.us-west-2.amazoncognito.com',
        domain: 'zk71rojmk1.execute-api.us-west-2.amazonaws.com/prod',
        redirectSignIn: ['https://test.flexi.domains'],
        redirectSignOut: ['https://portal.test.flexi.network'],
        region: 'us-west-2',
        userPoolId: 'us-west-2_UuiFFepVO',
        userPoolClientId: '4l6lu4764mgkk0s6jfq5ebq2c8',
        identityPoolId: 'us-west-2:519c8a72-fec8-444f-89a7-540dfcc90197',
    },
    dev: {
        // domain: 'flexinet-main-user-pool-dev.auth.us-west-2.amazoncognito.com',
        domain: 'ft8v2ll4uc.execute-api.us-west-2.amazonaws.com/prod',
        redirectSignIn: ['https://dev.flexi.domains'],
        redirectSignOut: ['https://portal.dev.flexi.network'],
        region: 'us-west-2',
        userPoolId: 'us-west-2_INBgfMat1',
        userPoolClientId: '52m9svts4nvks7qi0ft8lt0oct',
        identityPoolId: 'us-west-2:01fd1fa9-52a0-4934-90fa-75497ee92668',
    },
    ide: {
        // domain: 'flexinet-main-user-pool-dev.auth.us-west-2.amazoncognito.com',
        domain: 'ft8v2ll4uc.execute-api.us-west-2.amazonaws.com/prod',
        // domain: 'portal.dev.flexi.network',
        redirectSignIn: ['https://localhost:8021'],
        redirectSignOut: ['https://localhost:8011'],
        region: 'us-west-2',
        userPoolId: 'us-west-2_INBgfMat1',
        userPoolClientId: '52m9svts4nvks7qi0ft8lt0oct',
        identityPoolId: 'us-west-2:01fd1fa9-52a0-4934-90fa-75497ee92668',
    },
};


export const config = {
    Cognito: {
        // Amazon Cognito User Pool ID
        userPoolId: cognito[stage].userPoolId,

        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolClientId: cognito[stage].userPoolClientId,

        // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
        identityPoolId: cognito[stage].identityPoolId,

        // Set to true to use your identity pool's unauthenticated role when user is not logged in
        allowGuestAccess: true,

        loginWith: {
            oauth: {
                // Domain name
                domain: cognito[stage].domain,

                // Authorized scopes
                scopes: [
                    'phone',
                    'email',
                    'profile',
                    'openid',
                    'aws.cognito.signin.user.admin',
                ],

                // Callback URL
                redirectSignIn: cognito[stage].redirectSignIn,

                // Sign out URL
                redirectSignOut: cognito[stage].redirectSignOut,

                // 'code' for Authorization code grant,
                // 'token' for Implicit grant
                responseType: 'code',
            },
        }


    }
} as ResourcesConfig['Auth'];